'use client';

import { c as _c } from "react/compiler-runtime";
import { getSafeRedirectPath, useAuth } from '@repo/auth';
import { getApiErrorMessage } from '@repo/api';
import type { ApiErrorMessageEntry } from '@repo/api';
import { useAppForm } from '@repo/form';
import { z } from '@repo/schema';
import { useMutation } from '@repo/tanstack/query';
import { useBaseUpFetch } from '@repo/upfetch';
import { useRouter, useSearchParams } from 'next/navigation';
import { useState } from 'react';
import { LoginOutputSchema, loginSchema } from '@/app/@public/_components/login-form/schema.ts';
export const useLoginForm = () => {
  const $ = _c(23);
  const [errorMessage, setErrorMessage] = useState(null);
  const upfetch = useBaseUpFetch();
  const {
    login
  } = useAuth();
  const router = useRouter();
  const searchParams = useSearchParams();
  let t0;
  if ($[0] !== searchParams) {
    t0 = searchParams.get("reset");
    $[0] = searchParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const resetSuccess = t0 === "success";
  let t1;
  if ($[2] !== upfetch) {
    t1 = async input => upfetch("auth/login", {
      body: input,
      method: "POST",
      schema: LoginOutputSchema
    });
    $[2] = upfetch;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = error => {
      console.warn(error);
      setErrorMessage(getApiErrorMessage(error));
    };
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== login || $[6] !== router || $[7] !== searchParams) {
    t3 = async data => {
      setErrorMessage(null);
      await login(data.access_token, data.expires_in);
      const redirectTo = getSafeRedirectPath(searchParams.get("redirectTo"), "/");
      router.push(redirectTo);
      router.refresh();
    };
    $[5] = login;
    $[6] = router;
    $[7] = searchParams;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t1 || $[10] !== t3) {
    t4 = {
      mutationFn: t1,
      onError: t2,
      onSuccess: t3
    };
    $[9] = t1;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const {
    isPending,
    mutate
  } = useMutation(t4);
  let t5;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      email: "",
      password: ""
    };
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== mutate) {
    t6 = t7 => {
      const {
        value
      } = t7;
      setErrorMessage(null);
      mutate(value);
    };
    $[13] = mutate;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      onChange: loginSchema
    };
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t6) {
    t8 = {
      defaultValues: t5,
      onSubmit: t6,
      validators: t7
    };
    $[16] = t6;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  const form = useAppForm(t8);
  let t9;
  if ($[18] !== errorMessage || $[19] !== form || $[20] !== isPending || $[21] !== resetSuccess) {
    t9 = {
      errorMessage,
      form,
      isPending,
      resetSuccess
    };
    $[18] = errorMessage;
    $[19] = form;
    $[20] = isPending;
    $[21] = resetSuccess;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  return t9;
};